import { render } from "./Directory.vue?vue&type=template&id=eef0d00c"
import script from "./Directory.vue?vue&type=script&lang=js"
export * from "./Directory.vue?vue&type=script&lang=js"

import exportComponent from "/Users/greg/sites/queens/wp-content/themes/queens/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/twig/components/01-pages/Directory.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "eef0d00c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('eef0d00c', __exports__)) {
    api.reload('eef0d00c', __exports__)
  }
  
  module.hot.accept("./Directory.vue?vue&type=template&id=eef0d00c", () => {
    api.rerender('eef0d00c', render)
  })

}


export default __exports__